module.exports = __webpack_public_path__ + "75a6fb8bc1ef242be3dd273e4d1f52d2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/money-bg.png
 ** module id = 1547
 ** module chunks = 0
 **/